<template>
  <div class="admin-page">
    <h2 class="page-title">意见与留言</h2>
    <div class="admin-toolbar">
      <el-select v-model="filters.source" placeholder="来源" clearable class="filter-select" @change="fetchList">
        <el-option label="意见反馈" value="feedback" />
        <el-option label="联系我们" value="contact" />
      </el-select>
      <el-select v-model="filters.status" placeholder="状态" clearable class="filter-select" @change="fetchList">
        <el-option label="待处理" value="pending" />
        <el-option label="已处理" value="processed" />
      </el-select>
      <el-button type="primary" @click="fetchList">查询</el-button>
    </div>

    <el-table :data="items" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column label="来源" width="100">
        <template #default="s">{{ s.row.source === 'contact' ? '联系我们' : '意见反馈' }}</template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="100" />
      <el-table-column prop="email" label="邮箱" min-width="160" show-overflow-tooltip />
      <el-table-column prop="category" label="类型/主题" width="120" show-overflow-tooltip />
      <el-table-column prop="message" label="内容" min-width="220" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="90">
        <template #default="s">{{ s.row.status === 'processed' ? '已处理' : '待处理' }}</template>
      </el-table-column>
      <el-table-column label="时间" width="170">
        <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template #default="s">
          <el-button v-if="s.row.status === 'pending'" link type="primary" @click="openHandle(s.row)">处理</el-button>
          <span v-else>—</span>
        </template>
      </el-table-column>
    </el-table>

    <AdminPagination
      v-model:current-page="page"
      v-model:page-size="pageSize"
      :total="total"
      @size-change="fetchList"
      @current-change="fetchList"
    />

    <el-dialog v-model="handleVisible" title="处理留言" width="520px" destroy-on-close>
      <p v-if="currentRow"><strong>来自：</strong>{{ currentRow.name }} / {{ currentRow.email }}</p>
      <p v-if="currentRow?.category"><strong>类型/主题：</strong>{{ currentRow.category }}</p>
      <p v-if="currentRow"><strong>内容：</strong>{{ currentRow.message }}</p>
      <el-input v-model="adminReply" type="textarea" :rows="3" placeholder="可选：回复说明，登录用户会收到站内信" />
      <template #footer>
        <el-button @click="handleVisible = false">取消</el-button>
        <el-button type="primary" :loading="processing" @click="submitHandle">标记已处理</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import axios from 'axios'
import AdminPagination from '@/components/AdminPagination.vue'

export default {
  name: 'AdminInquiriesView',
  components: { AdminPagination },
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { source: '', status: 'pending' },
      handleVisible: false,
      processing: false,
      currentRow: null,
      adminReply: ''
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    authHeaders() {
      return { Authorization: `Bearer ${localStorage.getItem('jwt_token')}` }
    },
    formatTime(ts) {
      if (!ts) return ''
      return new Date(ts * 1000).toLocaleString('zh-CN')
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await axios.post(
          '/api/v1/admin/inquiry/list',
          {
            page: this.page,
            pageSize: this.pageSize,
            source: this.filters.source || undefined,
            status: this.filters.status || undefined
          },
          { headers: this.authHeaders() }
        )
        if (res.data?.code === 200) {
          this.items = res.data.data?.items || []
          this.total = res.data.data?.total || 0
        } else {
          ElMessage.error(res.data?.message || '加载失败')
        }
      } catch (e) {
        ElMessage.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    openHandle(row) {
      this.currentRow = row
      this.adminReply = ''
      this.handleVisible = true
    },
    async submitHandle() {
      if (!this.currentRow) return
      this.processing = true
      try {
        const res = await axios.post(
          '/api/v1/admin/inquiry/handle',
          { id: this.currentRow.id, adminReply: this.adminReply },
          { headers: this.authHeaders() }
        )
        if (res.data?.code === 200) {
          ElMessage.success('已处理')
          this.handleVisible = false
          this.fetchList()
        } else {
          ElMessage.error(res.data?.message || '处理失败')
        }
      } catch (e) {
        ElMessage.error('处理失败')
      } finally {
        this.processing = false
      }
    }
  }
}
</script>

<style scoped>
.page-title {
  margin: 0 0 16px;
  font-size: 1.25rem;
}
</style>
